// extracted by mini-css-extract-plugin
module.exports = {"balloon__area":"style_balloon__area__b_os3","balloon__object":"style_balloon__object__VSwtz","fly":"style_fly__AAH6M"};